import { defineNuxtPlugin } from '#app/nuxt'
import { LazyHeaderFooterExport, LazyBaseBuffering, LazyBaseChatbase, LazyBaseCursor, LazyBaseFlag, LazyBaseIcon, LazyBaseModal, LazyBaseModalVideo, LazyBaseModelViewer, LazyBaseForm, LazyBaseFormContactBox, LazyBaseFormSuccessModal, LazyBMAlert, LazyBMFooter, LazyBMHeaderRich, LazyBMHeaderRichInPage, LazyBMHeaderRichMenu, LazyBMHeaderRichQuickLinks, LazyBMHeaderRichQuickLinksCard, LazyBMHeaderRichQuickLinksCategory, LazyBmHeaderRichLanguageToggle, LazyBmHeaderRichMarketSelect, LazyBMHeaderStandard, LazyBMShoppingCart, LazyBMShoppingCartList, LazyCMAccordion, LazyCMCopy, LazyCMCopyMedia, LazyCMHighlights, LazyCMHorizontalScrolling, LazyCMMedia, LazyCMMediaCard, LazyCMMediaCardBase, LazyCMMediaCardWide, LazyCMMediaSection, LazyCMStage, LazyCMStageProductRich, LazyCMTable, LazyCMTextHighlight, LazyCorePage, LazyCorePageBlokModule, LazyCorePageBlokModuleWrapper, LazyCorePageLayer, LazyEMHomeTypes, LazyEMHome, LazyEMHome1Large2Small, LazyEMHome1Medium1Small, LazyEMHome1Medium2Small, LazyEMHome2Medium, LazyEMHomeCard, LazyEMHomeFooter, LazyEMHomeUtils, LazyEMMap, LazyEMMapModal, LazyMapStyles, LazyEMProductWidget, LazyEMShowroomTypes, LazyEMShowroom, LazyEMShowroomCardCC, LazyEMShowroomCardSP, LazyEMShowroomCardVideo, LazyEMShowroomCards, LazyEMShowroomFilters, LazyEMShowroomLoader, LazyEMShowroomMedia, LazyEMShowroomSensors, LazyEMShowroomStage, LazyEMShowroomVolumeAnimation, LazyFMContact, LazyFMNewsletter, LazyItemCardContent, LazyItemCardTeaser, LazyItemContentHead, LazyItemDropdownTypes, LazyItemDropdown, LazyItemDropdownList, LazyItemQuote, LazyItemTableFlexible, LazyItemTableStandard, LazyItemTableStandardCell, LazyLMDownloads, LazyLMGrid, LazyLMGridFilters, LazyLMGridIndustriesTypes, LazyLMGridIndustries, LazyLMGridIndustriesCard, LazyLMSlider, LazyTMGrid, LazyTMHighlight, LazyUtilAccordion, LazyUtilButton, LazyUtilFilterButton, LazyUtilImageResponsive, LazyUtilLinkItem, LazyUtilLinkItemIcon, LazyUtilLinkItemSubtext, LazyUtilMediaResponsive, LazyUtilRichtext, LazyUtilScrollable, LazyUtilStickyBar, LazyUtilTag, LazyUtilVideoScrub, LazyUtilYoutubeVideo, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["HeaderFooterExport", LazyHeaderFooterExport],
["BaseBuffering", LazyBaseBuffering],
["BaseChatbase", LazyBaseChatbase],
["BaseCursor", LazyBaseCursor],
["BaseFlag", LazyBaseFlag],
["BaseIcon", LazyBaseIcon],
["BaseModal", LazyBaseModal],
["BaseModalVideo", LazyBaseModalVideo],
["BaseModelViewer", LazyBaseModelViewer],
["BaseForm", LazyBaseForm],
["BaseFormContactBox", LazyBaseFormContactBox],
["BaseFormSuccessModal", LazyBaseFormSuccessModal],
["BMAlert", LazyBMAlert],
["BMFooter", LazyBMFooter],
["BMHeaderRich", LazyBMHeaderRich],
["BMHeaderRichInPage", LazyBMHeaderRichInPage],
["BMHeaderRichMenu", LazyBMHeaderRichMenu],
["BMHeaderRichQuickLinks", LazyBMHeaderRichQuickLinks],
["BMHeaderRichQuickLinksCard", LazyBMHeaderRichQuickLinksCard],
["BMHeaderRichQuickLinksCategory", LazyBMHeaderRichQuickLinksCategory],
["BmHeaderRichLanguageToggle", LazyBmHeaderRichLanguageToggle],
["BmHeaderRichMarketSelect", LazyBmHeaderRichMarketSelect],
["BMHeaderStandard", LazyBMHeaderStandard],
["BMShoppingCart", LazyBMShoppingCart],
["BMShoppingCartList", LazyBMShoppingCartList],
["CMAccordion", LazyCMAccordion],
["CMCopy", LazyCMCopy],
["CMCopyMedia", LazyCMCopyMedia],
["CMHighlights", LazyCMHighlights],
["CMHorizontalScrolling", LazyCMHorizontalScrolling],
["CMMedia", LazyCMMedia],
["CMMediaCard", LazyCMMediaCard],
["CMMediaCardBase", LazyCMMediaCardBase],
["CMMediaCardWide", LazyCMMediaCardWide],
["CMMediaSection", LazyCMMediaSection],
["CMStage", LazyCMStage],
["CMStageProductRich", LazyCMStageProductRich],
["CMTable", LazyCMTable],
["CMTextHighlight", LazyCMTextHighlight],
["CorePage", LazyCorePage],
["CorePageBlokModule", LazyCorePageBlokModule],
["CorePageBlokModuleWrapper", LazyCorePageBlokModuleWrapper],
["CorePageLayer", LazyCorePageLayer],
["EMHomeTypes", LazyEMHomeTypes],
["EMHome", LazyEMHome],
["EMHome1Large2Small", LazyEMHome1Large2Small],
["EMHome1Medium1Small", LazyEMHome1Medium1Small],
["EMHome1Medium2Small", LazyEMHome1Medium2Small],
["EMHome2Medium", LazyEMHome2Medium],
["EMHomeCard", LazyEMHomeCard],
["EMHomeFooter", LazyEMHomeFooter],
["EMHomeUtils", LazyEMHomeUtils],
["EMMap", LazyEMMap],
["EMMapModal", LazyEMMapModal],
["MapStyles", LazyMapStyles],
["EMProductWidget", LazyEMProductWidget],
["EMShowroomTypes", LazyEMShowroomTypes],
["EMShowroom", LazyEMShowroom],
["EMShowroomCardCC", LazyEMShowroomCardCC],
["EMShowroomCardSP", LazyEMShowroomCardSP],
["EMShowroomCardVideo", LazyEMShowroomCardVideo],
["EMShowroomCards", LazyEMShowroomCards],
["EMShowroomFilters", LazyEMShowroomFilters],
["EMShowroomLoader", LazyEMShowroomLoader],
["EMShowroomMedia", LazyEMShowroomMedia],
["EMShowroomSensors", LazyEMShowroomSensors],
["EMShowroomStage", LazyEMShowroomStage],
["EMShowroomVolumeAnimation", LazyEMShowroomVolumeAnimation],
["FMContact", LazyFMContact],
["FMNewsletter", LazyFMNewsletter],
["ItemCardContent", LazyItemCardContent],
["ItemCardTeaser", LazyItemCardTeaser],
["ItemContentHead", LazyItemContentHead],
["ItemDropdownTypes", LazyItemDropdownTypes],
["ItemDropdown", LazyItemDropdown],
["ItemDropdownList", LazyItemDropdownList],
["ItemQuote", LazyItemQuote],
["ItemTableFlexible", LazyItemTableFlexible],
["ItemTableStandard", LazyItemTableStandard],
["ItemTableStandardCell", LazyItemTableStandardCell],
["LMDownloads", LazyLMDownloads],
["LMGrid", LazyLMGrid],
["LMGridFilters", LazyLMGridFilters],
["LMGridIndustriesTypes", LazyLMGridIndustriesTypes],
["LMGridIndustries", LazyLMGridIndustries],
["LMGridIndustriesCard", LazyLMGridIndustriesCard],
["LMSlider", LazyLMSlider],
["TMGrid", LazyTMGrid],
["TMHighlight", LazyTMHighlight],
["UtilAccordion", LazyUtilAccordion],
["UtilButton", LazyUtilButton],
["UtilFilterButton", LazyUtilFilterButton],
["UtilImageResponsive", LazyUtilImageResponsive],
["UtilLinkItem", LazyUtilLinkItem],
["UtilLinkItemIcon", LazyUtilLinkItemIcon],
["UtilLinkItemSubtext", LazyUtilLinkItemSubtext],
["UtilMediaResponsive", LazyUtilMediaResponsive],
["UtilRichtext", LazyUtilRichtext],
["UtilScrollable", LazyUtilScrollable],
["UtilStickyBar", LazyUtilStickyBar],
["UtilTag", LazyUtilTag],
["UtilVideoScrub", LazyUtilVideoScrub],
["UtilYoutubeVideo", LazyUtilYoutubeVideo],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
